import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "my-2" }
const _hoisted_2 = { class: "flex items-center justify-between px-2" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "md:text-lg leading-4 font-semibold text-gray-900" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_6 = { class: "md:text-sm text-xs hover:underline" }
const _hoisted_7 = { class: "text-center pb-4" }
const _hoisted_8 = { class: "text-lg font-medium leading-6 text-gray-900" }
const _hoisted_9 = { class: "text-gray-600" }
const _hoisted_10 = { class: "text-left p-2 text-xs" }
const _hoisted_11 = { class: "flex py-2 gap-2" }
const _hoisted_12 = { class: "pl-2" }
const _hoisted_13 = {
  key: 1,
  class: "h-4 w-4"
}
const _hoisted_14 = { class: "pl-2 pb-2 md:pb-0" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { class: "col-span-1 font-semibold md:hidden" }
const _hoisted_17 = {
  key: 0,
  class: "col-span-2"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "flex justify-center pt-4" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "md:text-center pl-2 pt-2 md:p-0 md:text-base text-sm" }
const _hoisted_22 = {
  key: 0,
  class: "py-1 hidden md:flex gap-2 md:gap-4 px-2"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "w-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "delete")
], -1)
const _hoisted_24 = { class: "text-xs inline-flex md:hidden col-span-1 font-bold" }
const _hoisted_25 = { class: "col-span-2" }
const _hoisted_26 = { class: "items-center md:w-5/6 grid grid-cols-3 md:grid-cols-1" }
const _hoisted_27 = { class: "text-xs inline-flex md:hidden col-span-1 font-bold" }
const _hoisted_28 = { class: "col-span-2" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["disabled", "value", "onInput", "onKeydown", "id"]
const _hoisted_31 = {
  key: 0,
  class: "text-red block"
}
const _hoisted_32 = { class: "text-xs inline-flex md:hidden col-span-1 font-bold" }
const _hoisted_33 = ["disabled", "value", "onInput", "onKeydown", "id"]
const _hoisted_34 = {
  key: 0,
  class: "text-red block"
}
const _hoisted_35 = { class: "text-xs inline-flex md:hidden col-span-1 font-bold" }
const _hoisted_36 = ["value", "onInput", "placeholder", "id", "onKeydown"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "w-6 order-first md:order-last" }
const _hoisted_39 = { class: "flex justify-center w-full md:mt-6" }
const _hoisted_40 = { class: "flex justify-center" }
const _hoisted_41 = { class: "px-2 text-sm font-semibold text-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowsRightLeftIcon = _resolveComponent("ArrowsRightLeftIcon")!
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_PencilIcon = _resolveComponent("PencilIcon")!
  const _component_CopySectionData = _resolveComponent("CopySectionData")!
  const _component_MinusIcon = _resolveComponent("MinusIcon")!
  const _component_BasicModal = _resolveComponent("BasicModal")!
  const _component_SelectCombobox = _resolveComponent("SelectCombobox")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.editMode ? _ctx.$emit('addHighlight') : '')),
    class: _normalizeClass([
      { 'shadow-lg mix-blend-normal bg-blend-color-dodge': _ctx.editMode },
      'my-4 bg-white shadow sm:rounded-lg md:px-5 px-1  py-6 border',
      { 'border-yellow': _ctx.highlightSection === 'processes' },
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t(`report.section_title.processes`)), 1)
        ]),
        (!_ctx.approved)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.hasMergeableProcesses && !_ctx.approved)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "flex items-center text-gray-800 text-sm pr-2 hover:text-orange-500",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMergeModal && _ctx.openMergeModal(...args)))
                  }, [
                    _createVNode(_component_ArrowsRightLeftIcon, { class: "h-4 pr-1 text-bold" })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "flex items-center text-orange text-sm",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ((_ctx.copyDataOpen = true), (_ctx.searchDate = _ctx.yesterday)))
              }, [
                _createVNode(_component_CalendarIcon, { class: "h-4 pr-1" }),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("report.general.old_data_label")), 1)
              ]),
              (!_ctx.editMode)
                ? (_openBlock(), _createBlock(_component_PencilIcon, {
                    key: 1,
                    class: "w-4 h-4 text-oaiGray-300 cursor-pointer ml-3",
                    onClick: _ctx.activeEditMode
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_CopySectionData, {
          open: _ctx.copyDataOpen,
          date: _ctx.searchDate,
          onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyDataOpen = false)),
          onCopySectionData: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copySectionData($event), (_ctx.copyDataOpen = false)))
        }, null, 8, ["open", "date"]),
        _createVNode(_component_BasicModal, {
          open: _ctx.openMergeProcessesModal,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openMergeProcessesModal = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t("report.general.merge_processes_title")), 1),
              _createElementVNode("small", _hoisted_9, _toDisplayString(_ctx.$t("report.general.merge_processes_sub_title")), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.checkboxImbalancedNumber)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => ((_ctx.checkboxSelectAllProcesses = true), (_ctx.checkboxImbalancedNumber = false))),
                        class: "rounded bg-yellow-600 border-yellow-600 h-4 w-4 text-white focus:ring-yellow-600"
                      }, [
                        _createVNode(_component_MinusIcon)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.checkboxSelectAllProcesses) = $event)),
                          "aria-describedby": "process-checkbox-description",
                          name: "process-checkbox",
                          type: "checkbox",
                          class: "rounded border-gray-300 text-yellow-600 focus:ring-yellow-600"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.checkboxSelectAllProcesses]
                        ])
                      ]))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionConfig, (field, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: key,
                    class: _normalizeClass([field['width'], 'font-medium text-gray-600 hidden md:flex gap-2'])
                  }, _toDisplayString(_ctx.$t(`report.sections.processes.${key}`)), 3))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mergeableProcessesToEdit, (entry, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  class: _normalizeClass([
                entry.merge ? 'bg-yellow-100' : '',
                'text-xs text-gray-900 flex border-t border-200 py-2 relative md:flex-row gap-2 flex-col md:items-center',
              ])
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((entry.merge) = $event),
                      "aria-describedby": "process-checkbox-description",
                      name: "process-checkbox",
                      type: "checkbox",
                      class: "h-4 w-4 rounded border-gray-300 text-yellow-600 focus:ring-yellow-600"
                    }, null, 8, _hoisted_15), [
                      [_vModelCheckbox, entry.merge]
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry, (data, name, entryIdx) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: entryIdx }, [
                      (_ctx.sectionConfig.hasOwnProperty(`${name}`))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass([
                    _ctx.sectionConfig[name]?.['width'],
                    `order-${_ctx.sectionConfig[name]?.['order']}`,
                    'grid grid-cols-3 md:grid-cols-1 pl-2 md:pl-0',
                  ])
                          }, [
                            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t(`report.sections.processes.${name}`)), 1),
                            (
                      typeof data === 'object' && _ctx.sectionConfig[name]?.['field_type'] === 'combobox'
                    )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(data?.["mode"] === "default"
                        ? name === "process_type"
                          ? _ctx.$t(`process_classes.${data?.["value"]}`)
                          : _ctx.$t(`report.sections.processes.${name}_entries.${data?.["value"]}`)
                        : data?.["value"]), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(data === "" ? "-" : data), 1))
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ], 2))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_ctx.hasMergeableProcesses && !_ctx.approved)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.mergeProcesses())),
                    class: "animated-button rounded hover:bg-yellow hover:text-white bg-yellow text-white mx-0.5"
                  }, [
                    _createVNode(_component_ArrowsRightLeftIcon, { class: "w-full h-6 block m-0 box-border shrink-0" }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("report.general.merge_processes_button")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      (_ctx.approved && !_ctx.processes.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("report.general.section_empty")), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.editMode ? 'editInput' : 'overviewInput'])
    }, [
      (Object.keys(_ctx.groupedEntries).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionConfig, (field, key) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                (field['field_type'] !== 'time' || _ctx.settings?.site_duration.time_preview_enabled)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass([
              `${field?.['width'] ? field?.['width'] : ''}`,
              'font-medium truncate text-gray-600',
            ])
                    }, _toDisplayString(_ctx.$t(`report.sections.processes.${key}`)), 3))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _hoisted_23
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedEntries, (entryList, groupIdx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: groupIdx,
          class: "border-t"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entryList, (entry, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: _normalizeClass([
            'flex flex-wrap md:flex-nowrap px-2 py-2 gap-2 md:gap-4 relative tableRow border-gray-200 ',
            { 'items-center': !_ctx.validationError },
          ])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([
              _ctx.sectionConfig['process_type']['width'],
              _ctx.sectionConfig['process_type'].order,
              'grid grid-cols-3 md:grid-cols-1',
              { 'md:hidden': idx !== 0 },
            ])
              }, [
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("report.sections.processes.process_type")), 1),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_SelectCombobox, {
                    onUpdateEvent: ($event: any) => (_ctx.$emit('updateComboBox', 'process_type', $event, entry.id)),
                    onAddCustomField: ($event: any) => (
                  _ctx.$emit('addCustomField', $event, 'processes', 'process_type'),
                    _ctx.$emit('updateComboBox', 'process_type', $event, entry.id)
                ),
                    onDeleteCustomField: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('deleteCustomField', $event, 'processes', 'process_type'))),
                    onNextFocus: ($event: any) => (_ctx.nextFocus($event, groupIdx, idx, 'process_type', entryList.length)),
                    onDirectFocus: ($event: any) => (_ctx.focusInputField('processes', groupIdx, idx, 'process_type')),
                    editMode: _ctx.$props.editMode,
                    error: _ctx.validationError,
                    customFields: _ctx.customFields ? _ctx.customFieldsProcessSorted : [],
                    typeOfData: "process_type",
                    keyData: "processes",
                    initialSelectedOption: entry['process_type'],
                    tablePosition: { row: groupIdx + '-' + idx, firstCol: _ctx.isFirstCol(`process_type`) }
                  }, null, 8, ["onUpdateEvent", "onAddCustomField", "onNextFocus", "onDirectFocus", "editMode", "error", "customFields", "initialSelectedOption", "tablePosition"])
                ])
              ], 2),
              (idx !== 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass([
              _ctx.sectionConfig['process_type']['width'],
              _ctx.sectionConfig['process_type'].order,
              'hidden md:block',
            ])
                  }, null, 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass([
              _ctx.sectionConfig['location']['width'],
              _ctx.sectionConfig['location'].order,
              { 'md:flex justify-between items-center gap-1.5': idx === entryList.length - 1 },
            ])
              }, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("report.sections.processes.location")), 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_SelectCombobox, {
                      onNextFocus: ($event: any) => (_ctx.nextFocus($event, groupIdx, idx, 'location', entryList.length)),
                      onDirectFocus: ($event: any) => (_ctx.focusInputField('processes', groupIdx, idx, 'location')),
                      editMode: _ctx.$props.editMode,
                      customFields: _ctx.customFields ? _ctx.customFields['location'] : [],
                      typeOfData: "location",
                      keyData: "processes",
                      initialSelectedOption: entry['location'],
                      error: _ctx.validationError,
                      onUpdateEvent: ($event: any) => (_ctx.$emit('updateComboBox', 'location', $event, entry.id)),
                      onAddCustomField: ($event: any) => (
                    _ctx.$emit('addCustomField', $event, 'processes', 'location'),
                      _ctx.$emit('updateComboBox', 'location', $event, entry.id)
                  ),
                      onDeleteCustomField: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('deleteCustomField', $event, 'processes', 'location'))),
                      tablePosition: { row: groupIdx + '-' + idx, firstCol: _ctx.isFirstCol(`location`) }
                    }, null, 8, ["onNextFocus", "onDirectFocus", "editMode", "customFields", "initialSelectedOption", "error", "onUpdateEvent", "onAddCustomField", "tablePosition"])
                  ])
                ]),
                (_ctx.editMode)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass({ 'md:w-1/6 hidden md:block': _ctx.editMode })
                    }, [
                      (idx === entryList.length - 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.addNewProcessEntry(entry['process_type'])),
                            type: "button",
                            class: _normalizeClass([
                  'items-center p-1 shadow-sm xl:border-2 border border-yellow rounded-full text-yellow-700 hover:bg-yellow-700 hover:text-white focus:outline-none',
                  { 'item-start': _ctx.validationError },
                ])
                          }, [
                            _createVNode(_component_PlusIcon, { class: "w-3" })
                          ], 10, _hoisted_29))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true)
              ], 2),
              (_ctx.settings?.site_duration.time_preview_enabled)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass([
              _ctx.sectionConfig['start_time']['width'],
              _ctx.sectionConfig['start_time'].order,
              'grid grid-cols-3 md:grid-cols-1',
            ])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass([
                'text-xs inline-flex md:hidden col-span-1 font-bold',
                { 'md:block xl:hidden': _ctx.settings?.site_duration.time_preview_enabled },
              ])
                    }, _toDisplayString(_ctx.$t("report.sections.processes.start_time")), 3),
                    _createElementVNode("input", {
                      required: "",
                      type: "time",
                      name: "start_time",
                      class: "col-span-2 w-full oai-inputs",
                      disabled: !_ctx.editMode,
                      value: entry.start_time,
                      onInput: ($event: any) => (_ctx.$emit('updateFieldValue', $event, entry.id)),
                      onKeydown: _withKeys(_withModifiers(($event: any) => (
                _ctx.nextFocus($event, groupIdx, idx, 'start_time', entryList.length)
              ), ["prevent"]), ["enter"]),
                      id: `input-processes-${groupIdx}-${idx}-start_time`
                    }, null, 40, _hoisted_30),
                    (_ctx.validationError && entry['start_time']?.localeCompare(entry['end_time']) > 0)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(_ctx.$t("err.time")), 1))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.settings?.site_duration.time_preview_enabled)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass([
              _ctx.sectionConfig['end_time']['width'],
              _ctx.sectionConfig['end_time'].order,
              'grid grid-cols-3 md:grid-cols-1',
            ])
                  }, [
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("report.sections.processes.end_time")), 1),
                    _createElementVNode("input", {
                      required: "",
                      type: "time",
                      name: "end_time",
                      class: "col-span-2 oai-inputs",
                      disabled: !_ctx.editMode,
                      value: entry.end_time,
                      onInput: ($event: any) => (_ctx.$emit('updateFieldValue', $event, entry.id)),
                      onKeydown: _withKeys(_withModifiers(($event: any) => (
                _ctx.nextFocus($event, groupIdx, idx, 'end_time', entryList.length)
              ), ["prevent"]), ["enter"]),
                      id: `input-processes-${groupIdx}-${idx}-end_time`
                    }, null, 40, _hoisted_33),
                    (_ctx.validationError && entry['start_time']?.localeCompare(entry['end_time']) > 0)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_34, _toDisplayString(_ctx.$t("err.time")), 1))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass([
              _ctx.sectionConfig['note']['width'],
              _ctx.sectionConfig['note'].order,
              'grid grid-cols-3 md:grid-cols-1 xl:gap-4',
            ])
              }, [
                _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("report.sections.processes.note")), 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createElementBlock("textarea", {
                      key: 0,
                      rows: "2",
                      name: "note",
                      value: entry.note,
                      onInput: ($event: any) => (_ctx.$emit('updateFieldValue', $event, entry.id)),
                      placeholder: _ctx.$t('report.general.notes_placeholder'),
                      class: _normalizeClass([{ 'oai-inputs': _ctx.editMode }, 'col-span-2']),
                      id: `input-processes-${groupIdx}-${idx}-note`,
                      onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.nextFocus($event, groupIdx, idx, 'note', entryList.length)), ["prevent"]), ["enter"])
                    }, null, 42, _hoisted_36))
                  : _createCommentVNode("", true),
                (!_ctx.editMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("p", {
                        class: _normalizeClass([{ 'p-2': _ctx.editMode }, 'text-sm'])
                      }, _toDisplayString(entry["note"] !== "" ? entry["note"] : "-"), 3)
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("button", _hoisted_38, [
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock(_component_XMarkIcon, {
                      key: 0,
                      class: _normalizeClass({ 'w-6 text-red-900 hover:text-red': _ctx.editMode }),
                      onClick: ($event: any) => (_ctx.$emit('removeProcessEntry', entry, 'processes'))
                    }, null, 8, ["class", "onClick"]))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          }), 128))
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_39, [
        ((_ctx.editMode || _ctx.processes.length === 0) && !_ctx.approved)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addNewProcessEntry())),
              type: "button",
              class: "relative inline-flex items-center p-2 shadow-sm border-2 border-yellow rounded-full text-yellow-700 hover:bg-yellow-700 hover:text-white focus:outline-none"
            }, [
              _createVNode(_component_PlusIcon, { class: "w-6" })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_40, [
        (_ctx.hasMergeableProcesses && _ctx.mergeableProcesses.length > 0 && !_ctx.approved && !_ctx.editMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "flex justify-center bg-yellow-200 px-4 py-1 rounded-md items-center mt-6",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.openMergeModal && _ctx.openMergeModal(...args)))
            }, [
              _createVNode(_component_ArrowsRightLeftIcon, { class: "w-5 h-5 mr-1 text-yellow-700 inline-flex" }),
              _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t("report.general.merge_notification")), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 2))
}